import firebase from 'firebase'
require('dotenv').config()

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCWX38uiydDK0rdOz__4FiTmGKAUdoNPTQ",
  authDomain: "clone-636d0.firebaseapp.com",
  databaseURL: "https://clone-636d0.firebaseio.com",
  projectId: "clone-636d0",
  storageBucket: "clone-636d0.appspot.com",
  messagingSenderId: "513169104598",
  appId: "1:513169104598:web:1834793154a2a5d0bd3377",
  measurementId: "G-D5EN3TX5RE"
};

const firebaseApp = firebase.initializeApp(firebaseConfig)

const db = firebaseApp.firestore()
const auth = firebase.auth()

export { db, auth }